module.exports = __webpack_public_path__ + "img/נושא.bf6db23d.svg";